import { useMutation } from 'react-query'
import { postFileAPI } from 'framework/api/http'

interface GetStockOrderExportInterface {
  status?: any
  partnerId?: string
  starDate?: string
  endDate?: string
  searchKeyword?: string
  isExcel?: boolean
}

export const useGetStockOrderExport = () => {
  const mutate = useMutation(
    ({
      status,
      partnerId,
      starDate,
      endDate,
      searchKeyword,
      isExcel,
    }: GetStockOrderExportInterface) => {
      return postFileAPI(`/StockOrder/Export?From=${starDate}&To=${endDate}`, {
        IsNoRepeatitiveData: isExcel,
        SearchKeyword: searchKeyword === '' ? null : searchKeyword,
        Status: status?.[0] === 'ALL' || status?.[0] === 'All' ? null : status,
        PartnerId:
          partnerId === undefined || partnerId === '' ? null : partnerId,
      })
    },
  )
  return mutate
}

export default useGetStockOrderExport
